import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import "./Dashboard.scss";
import { auth, db } from "../../firebase";
import Footer from "../../components/Footer";
import Button from "../../components/Button";
import Loader from "../../components/Loader";
import Brand from "../../components/Brand";
import { brandsData } from "../../utils/brands/brands";
import { updateBrands } from "../../helpers/update-brands";
import { query, collection, where, getDocs } from "firebase/firestore";

const xidBlackLogo = require("../../assets/black-logo.png");
const xidWhiteLogo = require("../../assets/white-logo.png");
const profileImage = require("../../assets/profile-image.png");

export const Dashboard = () => {
  const [user, loading] = useAuthState(auth);
  const [isMobile, setIsMobile] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [brands, setBrands] = useState(brandsData);
  const [username, setUsername] = useState("");
  const navigate = useNavigate();

  const handleResize = () => {
    if (window.innerWidth <= 1200) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  const updateBrandsData = async () => {
    const { updatedBrands } = await updateBrands(brandsData, user?.uid || "");

    setBrands(updatedBrands);
    setIsLoading(false);
  };

  const fetchUserName = async () => {
    try {
      const q = query(collection(db, "users"), where("uid", "==", user?.uid));
      const doc = await getDocs(q);
      const data = doc.docs[0].data();

      setUsername(data.username);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching user data");
    }
  };

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
  });

  useEffect(() => {
    if (loading) return;
    if (!user) return navigate("/");

    updateBrandsData();
    fetchUserName();
  }, [user, loading]);

  return (
    <div
      className={`row dashboard-page page-wrapper ${
        !isMobile ? "desktop-background-image" : ""
      }`}
    >
      <div className="col m2 header-container">
        {isMobile ? (
          <div className="mobile-header">
            <img src={xidWhiteLogo}></img>
          </div>
        ) : (
          <img src={xidBlackLogo}></img>
        )}
      </div>
      <div className={`col m8 sections-container`}>
        {isLoading ? (
          <div className="loader">
            <Loader />
          </div>
        ) : (
          <div className="row">
            <div className="col m6">
              <div className="row profile-data-row">
                <div className="col m8 section-wrapper profile-wrapper">
                  <span className="text-profile-label">My profile</span>
                  <div className="profile-container">
                    <div className="image-wrapper">
                      <img src={profileImage} alt="" />
                      <span className="text-profile-label">{username}</span>
                    </div>
                    <div className="profile-info">
                      <span className="text-small">Earner since</span>
                      <span className="text-description">November 2022</span>
                    </div>
                    <div className="profile-info">
                      <span className="text-small">Total points earned</span>
                      <span className="text-description">6,490</span>
                    </div>
                    <div className="profile-info">
                      <span className="text-small">Rewards redeemed</span>
                      <span className="text-description">27</span>
                    </div>
                  </div>
                </div>
                <div className="col m4 section-wrapper points-wrapper">
                  <span className="text-profile-label">Points</span>
                  <div className="points-container">
                    <span className="text-main">You currently have</span>
                    <span className="text-title-bold">150</span>
                    <span className="text-header">points</span>
                  </div>
                  <div className="points-buttons-container">
                    <Button size="large" type="secondary">
                      Redeem Points
                    </Button>
                    <Button className="btn-outlined" outline={true}>
                      Earn More
                    </Button>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col m12 section-wrapper empty-section rewards-section">
                  <span className="text-profile-label">Rewards</span>
                </div>
              </div>
            </div>
            <div className="col m6">
              <div className="row brands-wrapper">
                <div className="col m12 section-wrapper">
                  <span className="text-profile-label">My brands</span>
                  {isMobile ? (
                    <div className="mobile-brands-container">
                      {brands.map((brand, index, elements) => {
                        if (index % 2 === 0) {
                          const nextBrand = elements[index + 1]
                            ? elements[index + 1]
                            : undefined;

                          return (
                            <div className="row mobile-brands-row">
                              <div key={brand.name} className="col m6">
                                <Brand
                                  logo={brand.icon}
                                  text={brand.name}
                                ></Brand>
                              </div>
                              <div key={nextBrand?.name} className="col m6">
                                {nextBrand && (
                                  <Brand
                                    logo={nextBrand.icon}
                                    text={nextBrand.name}
                                  ></Brand>
                                )}
                              </div>
                            </div>
                          );
                        }
                      })}
                    </div>
                  ) : (
                    <div className="brands-container">
                      <div>
                        {brands.map((brand, index) => {
                          if (index < 5 && brand.isSelected) {
                            return (
                              <Brand
                                logo={brand.icon}
                                text={brand.name}
                              ></Brand>
                            );
                          } else {
                            return <div className="empty-brand" />;
                          }
                        })}
                      </div>
                      <div>
                        {brands.map((brand, index) => {
                          if (index > 4 && brand.isSelected) {
                            return (
                              <Brand
                                logo={brand.icon}
                                text={brand.name}
                              ></Brand>
                            );
                          } else {
                            return <div className="empty-brand" />;
                          }
                        })}
                      </div>
                    </div>
                  )}

                  <div className="brands-button">
                    <Button
                      className="btn-outlined"
                      outline={true}
                      onClick={() => navigate("/personas")}
                    >
                      Manage & Explore
                    </Button>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col m12 section-wrapper empty-section">
                  <span className="text-profile-label">Connections</span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="col m2">
        <Footer />
      </div>
    </div>
  );
};
